module.exports = __webpack_public_path__ + "img/IMG_2493_L_BlackMatted.ffefe9f2.jpg";